const localStorageKeyNames = [
    'HekateHeartBeatFormInjection',
    'HekateQueryStringFormInjection',
    'SplitTestingPlugin',
    'PersonalizationProfile',
    'GetStartedAccountActivated',
    'OffsiteReferringUrl',
    'EbookHTML',
    'HekateProgressiveProfiles',
];
export const isValidLocalStorageKeyName = (key) => {
    return localStorageKeyNames.includes(key);
};
const sessionStorageKeyNames = ['VwoTestInfo'];
export const isValidSessionStorageKeyName = (key) => {
    return sessionStorageKeyNames.includes(key);
};
/** Cookies that we set */
const validCookieNames = [
    'OptanonConsent', // cookie that OneTrust Sets
    'emailVarForPreferenceCenter',
    'x-www-plan-group', // crossSession (i.e cross-session.jsp) Free, Pro, EDU, etc...
    'x-www-is-internal-developer', // from crossSession (i.e cross-session.jsp), true if the user visits heartBeat from a dev server
    'x-www-have-seen-on' /** from crossSession (i.e cross-session.jsp),
                  the timestamp in milliseconds when the user has had an "on" cookie, meaning they have logged in to the product at some point */,
];
export const isValidCookieName = (key) => {
    return validCookieNames.includes(key);
};
export const wwwPrefix = 'www-';
